import React from 'react';
import './HowWeHelp.css';
import background from '../../Assets/background_images/background4.png';

function CultureAndValues() {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img className='image' src={background} alt='hiring' />
        <div className='heading'>Organization Culture Building</div>
      </div>

      <div>
        <h1 className='title'>Organization Culture Building – YOUR FOUNDATION </h1>
        <p className='paragraph'>When it comes to hiring, most businesses are concerned with establishing whether or not the job candidate is a suitable match for the role. It takes a lot of time and effort to figure out if the person has the necessary abilities and expertise. Unfortunately, many firms have a difficult time deciding whether or not an application would be a suitable match for the organization, which includes cultural, value, mission, and team dynamics. This is referred to as "person-organization fit" by occupational psychologists and HR organizational development professionals (or P-O fit).</p>

        <ul className='outer-list'>
          <li>The possibility that someone would reflect and/or adapt to the underlying values, attitudes, and behaviors that make up your business is known as cultural fit.</li>
          <li>According to the Society for Human Resource Management, poor cultural fit leads to turnover, which may cost a company 50-60% of a person's yearly compensation (SHRM).</li>
          <li>Employees that get along well with their boss, coworkers, and supervisor have higher job satisfaction, are more likely to stay with the company, and perform better (Harvard Business Review).</li>
          <li>It is possible to quantify culture and values.</li>
        </ul>
      </div>
      <hr />

      <div>
        <h1 className='title'> How Strategic Links can help: </h1>

        <ul className='outer-list'>
          <li>Work Values & Attitude (WVA) by Strategic Links is a world-class diagnostic evaluation that determines how well an individual complements a business, allowing you to make smarter recruiting decisions.</li>
          <li>The attitudes, beliefs, perceptions, rules, and values of an organization's safety culture are referred to as safety culture. At all levels of the business, we can assist you in measuring behaviors and dedication to safety.</li>
        </ul>
      </div>
    </div>
  );
}

export default CultureAndValues;
